/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckProductionProjectResponse } from '../models/CheckProductionProjectResponse';
import type { PageableProductionProjectResponse } from '../models/PageableProductionProjectResponse';
import type { SingleProductionProjectResponse } from '../models/SingleProductionProjectResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductionProjectApi {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Create production project
   * @param id
   * @returns any Create production project
   * @throws ApiError
   */
  public createProductionProject(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/production-projects/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Wrong credentials`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get project by id
   * @param id
   * @returns SingleProductionProjectResponse Get project response
   * @throws ApiError
   */
  public getProductionProjectById(
    id: string,
  ): CancelablePromise<SingleProductionProjectResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/production-projects/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Get production projects
   * @param limit
   * @param offset
   * @param search
   * @param type
   * @param isPublic
   * @returns PageableProductionProjectResponse Get production projects
   * @throws ApiError
   */
  public getProductionProjects(
    limit?: (number | string),
    offset?: (number | string),
    search?: string,
    type?: string,
    isPublic?: string,
  ): CancelablePromise<PageableProductionProjectResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/production-projects',
      query: {
        'limit': limit,
        'offset': offset,
        'search': search,
        'type': type,
        'isPublic': isPublic,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Check project by id
   * @param id
   * @returns CheckProductionProjectResponse Get check project response
   * @throws ApiError
   */
  public checkProductionProjectById(
    id: string,
  ): CancelablePromise<CheckProductionProjectResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/production-projects/check/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

  /**
   * Complete project by id
   * @param id
   * @returns any Complete project response
   * @throws ApiError
   */
  public completeProductionProjectById(
    id: string,
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/production-projects/complete/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not found`,
        422: `Validation error`,
        500: `Something went wrong`,
      },
    });
  }

}
